export function isValidCpf(cpf) {
    if (!cpf) {
        return false;
    }
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf.length !== 11) {
        return false;
    }
    if (/^(\d)\1{10}$/.test(cpf)) {
        return false;
    }
    var calculateDigit = function (base, weights) {
        var sum = base
            .split('')
            .reduce(function (acc, num, index) { return acc + parseInt(num, 10) * weights[index]; }, 0);
        var remainder = sum % 11;
        return remainder < 2 ? 0 : 11 - remainder;
    };
    var weightsFirstDigit = [10, 9, 8, 7, 6, 5, 4, 3, 2];
    var weightsSecondDigit = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2];
    var baseCpf = cpf.substring(0, 9);
    var firstDigit = calculateDigit(baseCpf, weightsFirstDigit);
    var secondDigit = calculateDigit(baseCpf + firstDigit, weightsSecondDigit);
    return cpf === baseCpf + firstDigit.toString() + secondDigit.toString();
}
